import { render, staticRenderFns } from "./FileManager.vue?vue&type=template&id=588dfb86&scoped=true&"
import script from "./FileManager.vue?vue&type=script&lang=js&"
export * from "./FileManager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "588dfb86",
  null
  
)

export default component.exports